//POST INDIVISUAL ROLE
export const POST_ROLE_FETCH_START = "POST_ROLE_FETCH_START";
export const POST_ROLE_FETCH_SUCCESS = "POST_ROLE_FETCH_SUCCESS";
export const POST_ROLE_FETCH_FAILURE = "POST_ROLE_FETCH_FAILURE";

//ALL ROLE
export const ALL_ROLE_GET_START = "ALL_ROLE_GET_START";
export const ALL_ROLE_GET_SUCCESS = "ALL_ROLE_GET_SUCCESS";
export const ALL_ROLE_GET_FINISH = "ALL_ROLE_GET_FINISH";
